import React from "react";
import { useTranslation } from "react-i18next";

const ExperienceCollectionQuote = () => {
  const { t } = useTranslation();
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
        marginTop: "60px",
      }}
    >
      <div
        style={{
          textAlign: "center",
          maxWidth: "920px",
          width: "100%",
          borderBottom: "1px solid #000",
          padding: "60px 20px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div style={{ maxWidth: "600px" }}>
          <p className="made-36">{t("home.experience.quote.lead")}</p>
          <p className="made-22">{t("home.experience.quote.body")}</p>
        </div>
      </div>
      <div className="vert-line mbm-exclusion" style={{ height: "15vh" }}></div>
    </div>
  );
};

export default ExperienceCollectionQuote;
